module.exports = __webpack_public_path__ + "static/media/icon-transportation.bc43e153.svg";